module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-37-900-normal.af0fd86.woff2";